var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};

/**
 * @module Viewer
 * 
 */

OCS.Viewer.Config = {
    feeds_domain: OCS.Functions.get_ocs_feeds_domain(),
    domain: OCS.Functions.get_domain(),
    origin: document.location.origin,
    protocol: document.location.protocol,
    is_ie: OCS.Functions.is_ie(),
    is_edge: OCS.Functions.is_edge(),
    use_workers: true,
    use_shared_worker: true,
    ajaxManager: {storeCompletedReq: 60*60*1000},
    dataworker_start_time: 500,
    dataworker: {
        'class': 'DataWorker',
        'class_options': {
            actively_retrieve_data: true,
            ping_interval: 45000,
            pings_before_reporting: 1,
            xmpp_login_device: "",            
            xmpp_login_jid: 'anon.' + OCS.Functions.get_ocs_feeds_domain(),
            xmpp_node: OCS.Functions.get_ocs_feeds_domain()

        }
    },
    lightningworker: {
        'class': 'LightningWorker',
        'class_options': {
            time_update_interval: 60 * 1000
        }
    },

    /**
     * Default projection to use for data
     *
     * @property default_projection
     * @type {String}
     * @default EPSG:900913 -> EPSG:3857
     */
    default_projection: 'EPSG:3857',
    /**
     * Default projection to use for the map
     *
     * @property default_display_projection
     * @type {String}
     * @default EPSG:4326
     */
    default_display_projection: 'EPSG:4326',
    default_geog_simplification: 0.005,
    default_adv_simplification: 1,
    /**
     * Default longitude value to center on Oklahoma outline
     *
     * @property oklahoma_lon
     * @type {Float}
     * @default -98.765
     */
    oklahoma_lon: -98.765,
    /**
     * Default latitude value to center on Oklahoma outline
     *
     * @property oklahoma_lat
     * @type {Float}
     * @default 35.288
     */
    oklahoma_lat: 35.288,
    /**
     * Default zoom value to display only Oklahoma
     *
     * @property oklahoma_default_zoom
     * @type {Integer}
     * @default 3
     */
    oklahoma_default_zoom: 3,
    /**
     * @property oklahoma_bottom_left_coordinates Bottom left coordinates for a map to include in displaying all of Oklahoma
     * @type Array
     * @default [-103.0, 33.50]
     */
    oklahoma_bottom_left_coordinates: [-103.0, 33.50],

    /**
     * @property oklahoma_top_right_coordinates Top right coordinates for a map to include in displaying all of Oklahoma
     * @type Array
     * @default [-94.40, 37.0]
     */
    oklahoma_top_right_coordinates: [-94.40, 37.0],
    /**
     * Property to hold the default styles for the OK outline polygon
     *
     * @property ok_outline_style
     * @type {Object}
     */
    ok_outline_style: {
        fill: true,
        fillOpacity: 0,
        fillColor: '#ffffff',
        strokeColor: '#000000',
        strokeOpacity: 0.7,
        strokeWidth: 1.2
    },
    /**
     * Property to hold the default styles for the OK County polygons
     *
     * @property ok_counties_style
     * @type {Object}
     */
    ok_counties_style: {
        fill: true,
        fillOpacity: 0,
        fillColor: '#ffffff',
        strokeColor: '#000000',
        strokeOpacity: 0.2,
        strokeWidth: 1
    },
    obs_style: {
        label: "${product_value}",
        fontColor: "#000",
        fontSize: "16px",
        fontFamily: "Courier New, monospace",
        fontWeight: "normal",
        fillWidth: 1,
        labelAlign: "${align}",
        labelXOffset: "${xOffset}",
        labelYOffset: "${yOffset}",
        labelOutlineColor: "#fff",
        labelOutlineWidth: 5
    },
    grouped_layer_attribute: 'group',
    mask_style: {
        fillColor: '#E3E2E2',
        fillOpacity: 1,
        strokeOpacity: 0,
        strokeWidth: 'none'
    },
    nodejs_subscriptions_url: 'https://' + OCS.Functions.get_ocs_feeds_domain(), /* The value for this is set dynamically at the bottom of this file */
    site_config_url: '/find/siteinfo-json',
    xmpp_cmd_channel: 'app.cmds', // Channel to listen on for application commands
    events: {
        ADVISORY_OVER: 'advisory_over',
        ADVISORY_OUT: 'advisory_out',
        ADVISORY_CLICKED: 'advisory_clicked',
        ADVISORY_UNCLICKED: 'advisory_unclicked',
        APPLICATION_STOPPED: 'application_stopped',
        ANIMATION_BEGINNING_BUTTON_PUSHED: 'animation_beginning_button_pushed',
        ANIMATION_REVERSE_BUTTON_PUSHED: 'animation_reverse_button_pushed',
        ANIMATION_PLAY_BUTTON_PUSHED: 'animation_play_button_pushed',
        ANIMATION_PAUSE_BUTTON_PUSHED: 'animation_pause_button_pushed',
        ANIMATION_FORWARD_BUTTON_PUSHED: 'animation_forward_button_pushed',
        ANIMATION_END_BUTTON_PUSHED: 'animation_end_button_pushed',
        ANIMATION_ROCKER_BUTTON_PUSHED: 'animation_rocker_button_pushed',
        ANIMATION_LOOP_BUTTON_PUSHED: 'animation_loop_button_pushed',
        ANIMATION_SPEED_CHANGED: 'animation_speed_changed',
        ANIMATION_SCRUBBER_CHANGED: 'animation_scrubber_changed',
        DATAWORKER_ONLINE: 'dataworker_online',
        DATAWORKER_MESSAGE: 'dataworker_message',
        DATAWORKER_OffLINE: 'dataworker_offline',
        DESTROY_MAP: 'destroy_map',
        FRAME_CHANGED: 'frame_changed',
        FRAME_CONTENT_CHANGED: 'frame_content_changed',
        LAYER_DRAW_START: 'layer_draw_start',
        LAYER_DRAW_FINISH: 'layer_draw_finish',
        LAYER_VISIBILITY_CHANGED: 'layer_visibility_changed',
        LAYER_LEGEND_VISIBILITY_CHANGED: 'layer_legend_visibility_changed',
        LAYER_LEGEND_MOUSEMOVE_GRADIENT: 'layer_legend_mousemove_gradient',
        LAYER_LEGEND_MOUSEMOVE_RADAR: 'layer_legend_mousemove_radar',
        LAYER_LEGEND_MOUSEMOVE: 'layer_legend_mousemove',
        LINK_MAP: 'link_map',
        LOCK_ADVISORY_POPUP: 'advisory_lock_advisory_popup',
        MAP_LINKED: 'map_linked',
        MAP_UNLINKED: 'map_unlinked',
        MAP_PLAY_START: 'map_play_start',
        MAP_PAUSE_START: 'map_pause_start',
        MOUSE_MOVE: 'mouse_move',
        NEW_ADVISORY_EVENT: 'new_advisory_event',
        NEW_DATA_CALLBACK_FIRED: 'new_data_callback_fired',
        NEW_DATA_ARRIVAL: 'new_data_arrival',
        NEW_SOURCE_DATA_AVAILABLE: 'new_source_data',
        PRODUCT_DOWN: 'product_down',
        RADAR_UPDATED: 'radar_updated',
        REINIT_LAYERS: 'reinit_layers',
        RESTART_APPLICATION: 'restart_application',
        RENDER_HTML: 'render_html',
        SEND_GA_EVENT: 'send_ga_event',
        SHOW_CURRENT_LAYER: 'show_current_layer',
        TIMESTAMP_UPDATED: 'timestamp_updated',
        TOGGLE_LAYER_VISIBILITY: 'toggle_layer_visibility',
        TOGGLE_LAYER_LEGEND_VISIBILITY: 'toggle_layer_legend_visibility',
        UPDATE_PANEL_OPTIONS: 'update_panel_options',
        UNLINK_MAP: 'unlink_map',
        UNLOCK_ADVISORY_POPUP: 'advisory_unlock_advisory_popup',
        UPDATE_LAYERS: 'update_layers',
        UPDATE_URL_STATE: 'update_url_state',
        WORKER_THREAD_FINISHED: 'worker_thread_finished',
        XMPP_DEVICE_DISCONNECT: 'xmpp_device_disconnect',
        XMPP_DEVICE_KICKED: 'xmpp_device_kicked'
    },
    msgs: {
        xmpp_device_kicked_off: "This device has been disconnected due to a new desktop connection detected. Please keep in mind that only 1 browser is allowed to connect per computer.",
        xmpp_device_failed_to_connect: "This device has failed to connect to the xmpp server. Live updates not available. Try reloading the page or contacting the mesonet."
    },
    default_radar_locations: [
        {id: 'KAMA', name: 'Amarillo', status: '', lat: 35.23, lon: -101.71},
        {id: 'KDDC', name: 'Dodge City', status: '', lat: 37.76, lon: -99.97},
        {id: 'KDYX', name: 'Dyess AFB', status: '', lat: 32.53, lon: -99.25},
        {id: 'KFDR', name: 'Frederick', status: '', lat: 34.36, lon: -98.98},
        {id: 'KFWS', name: 'Fort Worth/Dallas', status: '', lat: 32.57, lon: -97.30},
        {id: 'KICT', name: 'Wichita', status: '', lat: 37.65, lon: -97.44},
        {id: 'KINX', name: 'Tulsa', status: '', lat: 36.17, lon: -95.56},
        {id: 'KLBB', name: 'Lubbock', status: '', lat: 33.65, lon: -101.81},
        {id: 'KLZK', name: 'Little Rock', status: '', lat: 34.84, lon: -92.26},
        {id: 'KPUX', name: 'Pueblo', status: '', lat: 38.46, lon: -104.18},
        {id: 'KSGF', name: 'Springfield', status: '', lat: 37.24, lon: -93.24},
        {id: 'KSHV', name: 'Shreveport', status: '', lat: 32.45, lon: -93.84},
        {id: 'KSRX', name: 'Fort Smith', status: '', lat: 35.29, lon: -94.36},
        {id: 'KTLX', name: 'Oklahoma City', status: '', lat: 35.33, lon: -97.28},
        {id: 'KVNX', name: 'Vance AFB', status: '', lat: 36.74, lon: -98.13}
    ],
    default_radar_products: [
        {product: 'N0B', name: 'BREF1'},
        {product: 'N1B', name: 'BREF2'},
        {product: 'N2B', name: 'BREF3'},
        {product: 'N3B', name: 'BREF4'},
        {product: 'N0G', name: 'BVEL1'},
        {product: 'N1G', name: 'BVEL2'},
        {product: 'N2U', name: 'BVEL3'},
        {product: 'N3U', name: 'BVEL4'},
        {product: 'SSRVEL1', name: 'SRVEL1'},
        {product: 'SSRVEL2', name: 'SRVEL2'},
        {product: 'ESRVEL3', name: 'SRVEL3'},
        {product: 'ESRVEL4', name: 'SRVEL4'},
        {product: 'N0C', name: 'CC1'},
        {product: 'N1C', name: 'CC2'},
        {product: 'N2C', name: 'CC3'},
        {product: 'N3C', name: 'CC4'},
        {product: 'N0X', name: 'ZDR1'},
        {product: 'N1X', name: 'ZDR2'},
        {product: 'N2X', name: 'ZDR3'},
        {product: 'N3X', name: 'ZDR4'},
        {product: 'N0K', name: 'KDP1'},
        {product: 'N1K', name: 'KDP2'},
        {product: 'N2K', name: 'KDP3'},
        {product: 'N3K', name: 'KDP4'},
        {product: 'N0H', name: 'HC1'},
        {product: 'N1H', name: 'HC2'},
        {product: 'N2H', name: 'HC3'},
        {product: 'N3H', name: 'HC4'}
    ],
    resolution_to_simplification:{
        500: 0,
        4000: 0.005,
        8000: 1
    },
    geometry_manager_defaults: {
        time_to_request: 0,
        max_ids_to_request: 1,
        request_method: "GET"
    },
    datasets: {
        "tracker": {
            "dataset": "tracker",
            "datatype": "tracker"
        },
        "userdata": {
            "dataset": "userdata",
            "datatype": "userdata"
        }
    },
    advisory_info: {
        "filtered_wfo_ids": [
            'KTSA', 'KOUN', 'KAMA', 'KSHV', 'KFWD', 'KICT', 'KSGF', 'KPUB', 'KDDC', 'KABQ', 'KLZK', 'KLUB', 'KSJT'
        ],
        "warning_types": [
            'TOR', 'SVR', 'FFW'
        ]
    },
    lightning_info: {
        default_states: ['OK', 'TX', 'NM', 'CO', 'KS', 'MO', 'AR', 'LA']
    },
    param_info: {
        "parm": [
            {
                "id": "relh",
                "type": "float",
                "units": "prct",
                "name": "relative humidity",
                "short_name": "relative humidity"
            },
            {
                "id": "speh",
                "type": "float",
                "units": "gpkg",
                "name": "specific humidity",
                "short_name": "specific humidity"
            },
            {
                "id": "srad",
                "type": "float",
                "units": "wpsm",
                "name": "solar radiation",
                "short_name": "solar radiation"
            },
            {
                "id": "exsr",
                "type": "float",
                "units": "wpsm",
                "name": "theoretical maximum solar radiation",
                "short_name": "theoretical maximum solar radiation"
            },
            {
                "id": "rain",
                "type": "float",
                "units": "mm",
                "unitset": "prec",
                "name": "rainfall since midnight UTC",
                "short_name": "rainfall since midnight UTC"
            },
            {
                "id": "rtip",
                "type": "float",
                "units": "nada",
                "unitset": "prec",
                "name": "rainfall since midnight UTC",
                "short_name": "rainfall since midnight UTC"
            },
            {
                "id": "tair",
                "type": "float",
                "units": "cels",
                "name": "air temperature at 1.5 m",
                "short_name": "air temp 1.5 m"
            },
            {
                "id": "ta9m",
                "type": "float",
                "units": "cels",
                "name": "air temperature at 9 m",
                "short_name": "air temp 9 m"
            },
            {
                "id": "ts05",
                "type": "float",
                "units": "cels",
                "name": "sod temperature at 5 cm",
                "short_name": "sod temp 5 cm"
            },
            {
                "id": "tb05",
                "type": "float",
                "units": "cels",
                "name": "soil temperature at 5 cm",
                "short_name": "soil temp 5 cm"
            },
            {
                "id": "ts10",
                "type": "float",
                "units": "cels",
                "name": "sod temperature at 10 cm",
                "short_name": "sod temp 10 cm"
            },
            {
                "id": "tb10",
                "type": "float",
                "units": "cels",
                "name": "soil temperature at 10 cm",
                "short_name": "soil temp 10 cm"
            },
            {
                "id": "ts30",
                "type": "float",
                "units": "cels",
                "name": "sod temperature at 30 cm",
                "short_name": "sod temp 30 cm"
            },
            {
                "id": "ts50",
                "type": "float",
                "units": "cels",
                "name": "sod temperature at 50 cm",
                "short_name": "sod temp 50 cm"
            },
            {
                "id": "tdew",
                "type": "float",
                "units": "cels",
                "name": "dewpoint temperature",
                "short_name": "dewpoint temp"
            },
            {
                "id": "dewd",
                "type": "float",
                "units": "celsd",
                "name": "dewpoint depression",
                "short_name": "dewpoint depression"
            },
            {
                "id": "vdef",
                "type": "float",
                "units": "mb",
                "name": "vapor deficit",
                "short_name": "vapor deficit"
            },
            {
                "id": "wind10m",
                "name": "winds at 10 meters",
                "short_name": "Wind 10m",
                "units": "mps",
                "samag": "wspd",
                "vamag": "wvec",
                "dir": "wdir",
                "ucomp": "uwnd",
                "vcomp": "vwnd",
                "gust": "wmax"
            },
            {
                "id": "wind2m",
                "name": "winds at 2 meters",
                "short_name": "Wind 2m",
                "units": "mps",
                "samag": "ws2m",
                "vamag": "wvec",
                "dir": "wdir",
                "ucomp": "uwnd2",
                "vcomp": "vwnd2",
                "gust": "wmax"
            },
            {
                "id": "tapp",
                "type": "float",
                "units": "fahr",
                "name": "apparent temperature",
                "short_name": "apparent temp"
            },
            {
                "id": "chil",
                "type": "float",
                "units": "fahr",
                "name": "wind chill index",
                "short_name": "wind chill"
            },
            {
                "id": "chil2",
                "type": "float",
                "units": "fahr",
                "name": "wind chill index, but tair is returned if wspd is less than 3 mph",
                "short_name": "wind chill index, but tair is returned if wspd is less than 3 mph"
            },
            {
                "id": "heat",
                "type": "float",
                "units": "fahr",
                "name": "heat index",
                "short_name": "heat index"
            },
            {
                "id": "hdeg",
                "type": "float",
                "units": "nada",
                "name": "heating degree days (base 65 F)",
                "short_name": "heating degree days (base 65 F)"
            },
            {
                "id": "cdeg",
                "type": "float",
                "units": "nada",
                "name": "cooling degree days (base 65 F)",
                "short_name": "cooling degree days (base 65 F)"
            },
            {
                "id": "thte",
                "type": "float",
                "units": "kelv",
                "name": "equivalent potential temperature",
                "short_name": "equivalent potential temperature"
            },
            {
                "id": "tvir",
                "type": "float",
                "units": "kelv",
                "name": "virtual temperature",
                "short_name": "virtual temperature"
            },
            {
                "id": "thta",
                "type": "float",
                "units": "kelv",
                "name": "potential temperature",
                "short_name": "potential temperature"
            },
            {
                "id": "twet",
                "type": "float",
                "units": "cels",
                "name": "web bulb temperature",
                "short_name": "web bulb temp"
            },
            {
                "id": "tpan",
                "type": "float",
                "units": "cels",
                "name": "panel temperature temperature",
                "short_name": "panel temperature temperature"
            },
            {
                "id": "wspd",
                "type": "float",
                "units": "mps",
                "name": "wind speed at 10 m",
                "short_name": "10m wind spd"
            },
            {
                "id": "ws2m",
                "type": "float",
                "units": "mps",
                "name": "wind speed at 2 m",
                "short_name": "wind speed at 2 m"
            },
            {
                "id": "wvec",
                "type": "float",
                "units": "mps",
                "name": "vector average wind speed",
                "short_name": "vector average wind speed"
            },
            {
                "id": "wmax",
                "type": "float",
                "units": "mps",
                "name": "maximum wind speed",
                "short_name": "maximum wind speed"
            },
            {
                "id": "wmx9",
                "type": "float",
                "units": "mps",
                "name": "maximum wind speed at 9 m",
                "short_name": "maximum wind speed at 9 m"
            },
            {
                "id": "wssd",
                "type": "float",
                "units": "mps",
                "name": "standard deviation of wind speed",
                "short_name": "standard deviation of wind speed"
            },
            {
                "id": "wsd2",
                "type": "float",
                "units": "mps",
                "name": "standard deviation of wind speed at 2 m",
                "short_name": "standard deviation of wind speed at 2 m"
            },
            {
                "id": "wsd9",
                "type": "float",
                "units": "mps",
                "name": "standard deviation of wind speed at 9 m",
                "short_name": "standard deviation of wind speed at 9 m"
            },
            {
                "id": "wdir",
                "type": "float",
                "units": "degr",
                "name": "wind direction at 10 m",
                "short_name": "wind direction at 10 m"
            },
            {
                "id": "rose",
                "type": "float",
                "units": "nada",
                "name": "cardinal wind direction at 10 m",
                "short_name": "cardinal wind direction at 10 m"
            },
            {
                "id": "wdsd",
                "type": "float",
                "units": "degr",
                "name": "standard deviation of wind direction",
                "short_name": "standard deviation of wind direction"
            },
            {
                "id": "uwnd",
                "type": "float",
                "units": "mps",
                "name": "wind vector U component",
                "short_name": "wind vector U component"
            },
            {
                "id": "vwnd",
                "type": "float",
                "units": "mps",
                "name": "wind vector V component",
                "short_name": "wind vector V component"
            },
            {
                "id": "uwnd2",
                "type": "float",
                "units": "mps",
                "name": "wind vector U component, 2 meters",
                "short_name": "wind vector U component, 2 meters"
            },
            {
                "id": "vwnd2",
                "type": "float",
                "units": "mps",
                "name": "wind vector V component, 2 meters",
                "short_name": "wind vector V component, 2 meters"
            },
            {
                "id": "pres",
                "type": "float",
                "units": "mbar",
                "name": "pressure",
                "short_name": "pressure"
            },
            {
                "id": "palt",
                "type": "float",
                "units": "mbar",
                "name": "altimeter setting",
                "short_name": "altimeter setting"
            },
            {
                "id": "vapr",
                "type": "float",
                "units": "mbar",
                "name": "vapor pressure",
                "short_name": "vapor pressure"
            },
            {
                "id": "vaps",
                "type": "float",
                "units": "mbar",
                "name": "saturation vapor pressure",
                "short_name": "saturation vapor pressure"
            },
            {
                "id": "mixr",
                "type": "float",
                "units": "gpkg",
                "name": "mixing ratio",
                "short_name": "mixing ratio"
            },
            {
                "id": "mixs",
                "type": "float",
                "units": "gpkg",
                "name": "saturation mixing ratio",
                "short_name": "saturation mixing ratio"
            },
            {
                "id": "tlcl",
                "type": "float",
                "units": "kelv",
                "name": "LCL temperature",
                "short_name": "LCL temperature"
            },
            {
                "id": "leaf",
                "type": "float",
                "units": "prct",
                "name": "Leaf wetness",
                "short_name": "Leaf wetness"
            },
            {
                "id": "ls10",
                "type": "float",
                "units": "cels",
                "name": "Lysimeter soil temp at 10cm",
                "short_name": "Lysimeter soil temp at 10cm"
            },
            {
                "id": "vw05",
                "type": "float",
                "units": "m^3/m^3",
                "name": "Volumetric Water at 5cm",
                "short_name": "Volumetric Water at 5cm"
            },
            {
                "id": "ls30",
                "type": "float",
                "units": "cels",
                "name": "Lysimeter soil temp at 30cm",
                "short_name": "Lysimeter soil temp at 30cm"
            },
            {
                "id": "lys1",
                "type": "float",
                "units": "nada",
                "name": "Lysimeter load cell no. 1 output",
                "short_name": "Lysimeter load cell no. 1 output"
            },
            {
                "id": "lys2",
                "type": "float",
                "units": "nada",
                "name": "Lysimeter load cell no. 2 output",
                "short_name": "Lysimeter load cell no. 2 output"
            },
            {
                "id": "lys3",
                "type": "float",
                "units": "nada",
                "name": "Lysimeter load cell no. 3 output",
                "short_name": "Lysimeter load cell no. 3 output"
            },
            {
                "id": "lys4",
                "type": "float",
                "units": "nada",
                "name": "Lysimeter load cell no. 4 output",
                "short_name": "Lysimeter load cell no. 4 output"
            },
            {
                "id": "paw10",
                "type": "float",
                "units": "mm",
                "name": "plant available water in top 10cm",
                "short_name": "plant available water in top 10cm"
            },
            {
                "id": "paw40",
                "type": "float",
                "units": "mm",
                "name": "plant available water in top 40cm",
                "short_name": "plant available water in top 40cm"
            },
            {
                "id": "paw80",
                "type": "float",
                "units": "mm",
                "name": "plant available water in top 80cm",
                "short_name": "plant available water in top 80cm"
            },
            {
                "id": "parm05_list",
                "type": "string",
                "units": "nada",
                "name": "5 minute parameter list",
                "short_name": "5 minute parameter list"
            },
            {
                "id": "parm15_list",
                "type": "string",
                "units": "nada",
                "name": "15 minute parameter list",
                "short_name": "15 minute parameter list"
            },
            {
                "id": "parm30_list",
                "type": "string",
                "units": "nada",
                "name": "30 minute parameter list",
                "short_name": "30 minute parameter list"
            },
            {
                "id": "seconds",
                "type": "float",
                "units": "secs",
                "name": "seconds into day of observation",
                "short_name": "seconds into day of observation"
            },
            {
                "id": "lat",
                "type": "float",
                "units": "degr",
                "name": "latitude",
                "short_name": "latitude"
            },
            {
                "id": "lon",
                "type": "float",
                "units": "degr",
                "name": "longitude",
                "short_name": "longitude"
            },
            {
                "id": "elev",
                "type": "float",
                "units": "m",
                "unitset": "dist",
                "name": "elevation",
                "short_name": "elevation"
            },
            {
                "id": "name",
                "type": "string",
                "units": "nada",
                "name": "site name",
                "short_name": "site name"
            },
            {
                "id": "stid",
                "type": "string",
                "units": "nada",
                "name": "site ID",
                "short_name": "site ID"
            },
            {
                "id": "stnm",
                "type": "int",
                "units": "nada",
                "name": "site number",
                "short_name": "site number"
            },
            {
                "id": "cldv",
                "type": "int",
                "units": "nada",
                "name": "climate division",
                "short_name": "climate division"
            },
            {
                "id": "wcr05",
                "type": "float",
                "units": "m3m3",
                "name": "residual water content at 5 cm",
                "short_name": "residual water content at 5 cm"
            },
            {
                "id": "wcr25",
                "type": "float",
                "units": "m3m3",
                "name": "residual water content at 25 cm",
                "short_name": "residual water content at 25 cm"
            },
            {
                "id": "wcr60",
                "type": "float",
                "units": "m3m3",
                "name": "residual water content at 60 cm",
                "short_name": "residual water content at 60 cm"
            },
            {
                "id": "wcr75",
                "type": "float",
                "units": "m3m3",
                "name": "residual water content at 75 cm",
                "short_name": "residual water content at 75 cm"
            },
            {
                "id": "wcs05",
                "type": "float",
                "units": "m3m3",
                "name": "saturated water content at 5 cm",
                "short_name": "saturated water content at 5 cm"
            },
            {
                "id": "wcs25",
                "type": "float",
                "units": "m3m3",
                "name": "saturated water content at 25 cm",
                "short_name": "saturated water content at 25 cm"
            },
            {
                "id": "wcs60",
                "type": "float",
                "units": "m3m3",
                "name": "saturated water content at 60 cm",
                "short_name": "saturated water content at 60 cm"
            },
            {
                "id": "wcs75",
                "type": "float",
                "units": "m3m3",
                "name": "saturated water content at 75 cm",
                "short_name": "saturated water content at 75 cm"
            },
            {
                "id": "a05",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant a at 5 cm",
                "short_name": "empirical soil moisture constant a at 5 cm"
            },
            {
                "id": "a25",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant a at 25 cm",
                "short_name": "empirical soil moisture constant a at 25 cm"
            },
            {
                "id": "a60",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant a at 60 cm",
                "short_name": "empirical soil moisture constant a at 60 cm"
            },
            {
                "id": "a75",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant a at 75 cm",
                "short_name": "empirical soil moisture constant a at 75 cm"
            },
            {
                "id": "n05",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant n at 5 cm",
                "short_name": "empirical soil moisture constant n at 5 cm"
            },
            {
                "id": "n25",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant n at 25 cm",
                "short_name": "empirical soil moisture constant n at 25 cm"
            },
            {
                "id": "n60",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant n at 60 cm",
                "short_name": "empirical soil moisture constant n at 60 cm"
            },
            {
                "id": "n75",
                "type": "float",
                "units": "nada",
                "name": "empirical soil moisture constant n at 75 cm",
                "short_name": "empirical soil moisture constant n at 75 cm"
            },
            {
                "id": "ft05",
                "type": "float",
                "units": "cels",
                "name": "soil moisture final temperature at 5 cm",
                "short_name": "soil moisture final temperature at 5 cm"
            },
            {
                "id": "ft25",
                "type": "float",
                "units": "cels",
                "name": "soil moisture final temperature at 25 cm",
                "short_name": "soil moisture final temperature at 25 cm"
            },
            {
                "id": "ft60",
                "type": "float",
                "units": "cels",
                "name": "soil moisture final temperature at 60 cm",
                "short_name": "soil moisture final temperature at 60 cm"
            },
            {
                "id": "ft75",
                "type": "float",
                "units": "cels",
                "name": "soil moisture final temperature at 75 cm",
                "short_name": "soil moisture final temperature at 75 cm"
            },
            {
                "id": "st05",
                "type": "float",
                "units": "cels",
                "name": "soil moisture start temperature at 5 cm",
                "short_name": "soil moisture start temperature at 5 cm"
            },
            {
                "id": "st25",
                "type": "float",
                "units": "cels",
                "name": "soil moisture start temperature at 25 cm",
                "short_name": "soil moisture start temperature at 25 cm"
            },
            {
                "id": "st60",
                "type": "float",
                "units": "cels",
                "name": "soil moisture start temperature at 60 cm",
                "short_name": "soil moisture start temperature at 60 cm"
            },
            {
                "id": "st75",
                "type": "float",
                "units": "cels",
                "name": "soil moisture start temperature at 75 cm",
                "short_name": "soil moisture start temperature at 75 cm"
            },
            {
                "id": "tref",
                "type": "float",
                "units": "cels",
                "name": "reference temperature",
                "short_name": "reference temperature"
            },
            {
                "id": "dt05",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture delta temperature at 5 cm",
                "short_name": "soil moisture delta temperature at 5 cm"
            },
            {
                "id": "dt25",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture delta temperature at 25 cm",
                "short_name": "soil moisture delta temperature at 25 cm"
            },
            {
                "id": "dt60",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture delta temperature at 60 cm",
                "short_name": "soil moisture delta temperature at 60 cm"
            },
            {
                "id": "dt75",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture delta temperature at 75 cm",
                "short_name": "soil moisture delta temperature at 75 cm"
            },
            {
                "id": "tr05",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture reference temperature at 5 cm",
                "short_name": "soil moisture reference temperature at 5 cm"
            },
            {
                "id": "tr25",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture reference temperature at 25 cm",
                "short_name": "soil moisture reference temperature at 25 cm"
            },
            {
                "id": "tr60",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture reference temperature at 60 cm",
                "short_name": "soil moisture reference temperature at 60 cm"
            },
            {
                "id": "tr75",
                "type": "float",
                "units": "celsd",
                "name": "soil moisture reference temperature at 75 cm",
                "short_name": "soil moisture reference temperature at 75 cm"
            },
            {
                "id": "mp05",
                "type": "float",
                "units": "kpas",
                "name": "matric potential at 5 cm",
                "short_name": "matric potential at 5 cm"
            },
            {
                "id": "mp25",
                "type": "float",
                "units": "kpas",
                "name": "matric potential at 25 cm",
                "short_name": "matric potential at 25 cm"
            },
            {
                "id": "mp60",
                "type": "float",
                "units": "kpas",
                "name": "matric potential at 60 cm",
                "short_name": "matric potential at 60 cm"
            },
            {
                "id": "mp75",
                "type": "float",
                "units": "kpas",
                "name": "matric potential at 75 cm",
                "short_name": "matric potential at 75 cm"
            },
            {
                "id": "wc05",
                "type": "float",
                "units": "m3m3",
                "name": "volumetric water content at 5 cm",
                "short_name": "volumetric water content at 5 cm"
            },
            {
                "id": "wc25",
                "type": "float",
                "units": "m3m3",
                "name": "volumetric water content at 25 cm",
                "short_name": "volumetric water content at 25 cm"
            },
            {
                "id": "wc60",
                "type": "float",
                "units": "m3m3",
                "name": "volumetric water content at 60 cm",
                "short_name": "volumetric water content at 60 cm"
            },
            {
                "id": "wc75",
                "type": "float",
                "units": "m3m3",
                "name": "volumetric water content at 75 cm",
                "short_name": "volumetric water content at 75 cm"
            },
            {
                "id": "wcwp05",
                "type": "float",
                "units": "m3m3",
                "name": "water content at wilting point at 5 cm",
                "short_name": "water content at wilting point at 5 cm"
            },
            {
                "id": "wcwp25",
                "type": "float",
                "units": "m3m3",
                "name": "water content at wilting point at 25 cm",
                "short_name": "water content at wilting point at 25 cm"
            },
            {
                "id": "wcwp60",
                "type": "float",
                "units": "m3m3",
                "name": "water content at wilting point at 60 cm",
                "short_name": "water content at wilting point at 60 cm"
            },
            {
                "id": "fw05",
                "type": "float",
                "units": "nada",
                "name": "fractional water index at 5 cm",
                "short_name": "fractional water index at 5 cm"
            },
            {
                "id": "fw25",
                "type": "float",
                "units": "nada",
                "name": "fractional water index at 25 cm",
                "short_name": "fractional water index at 25 cm"
            },
            {
                "id": "fw60",
                "type": "float",
                "units": "nada",
                "name": "fractional water index at 60 cm",
                "short_name": "fractional water index at 60 cm"
            },
            {
                "id": "fw75",
                "type": "float",
                "units": "nada",
                "name": "fractional water index at 75 cm",
                "short_name": "fractional water index at 75 cm"
            },
            {
                "id": "cm05",
                "type": "float",
                "units": "nada",
                "name": "categorized matric potential at 5 cm",
                "short_name": "categorized matric potential at 5 cm"
            },
            {
                "id": "cm25",
                "type": "float",
                "units": "nada",
                "name": "categorized matric potential at 25 cm",
                "short_name": "categorized matric potential at 25 cm"
            },
            {
                "id": "cm60",
                "type": "float",
                "units": "nada",
                "name": "categorized matric potential at 60 cm",
                "short_name": "categorized matric potential at 60 cm"
            },
            {
                "id": "cm75",
                "type": "float",
                "units": "nada",
                "name": "categorized matric potential at 75 cm",
                "short_name": "categorized matric potential at 75 cm"
            },
            {
                "id": "bvas",
                "type": "float",
                "units": "volt",
                "name": "aspirator battery voltage",
                "short_name": "aspirator battery voltage"
            },
            {
                "id": "fans",
                "type": "float",
                "units": "volt",
                "name": "aspirator fan speed",
                "short_name": "aspirator fan speed"
            },
            {
                "id": "taux",
                "type": "float",
                "units": "volt",
                "name": "auxillary power supply controller temperature",
                "short_name": "auxillary power supply controller temperature"
            },
            {
                "id": "batv",
                "type": "float",
                "units": "volt",
                "name": "battery voltage",
                "short_name": "battery voltage"
            },
            {
                "id": "flsv",
                "type": "float",
                "units": "nada",
                "name": "flag status value",
                "short_name": "flag status value"
            },
            {
                "id": "tslo",
                "type": "float",
                "units": "cels",
                "name": "slow air temperature at 1.5 m",
                "short_name": "slow air temperature at 1.5 m"
            },
            {
                "id": "ta15",
                "type": "float",
                "units": "cels",
                "name": "fast air temperature at 1.5 m",
                "short_name": "fast air temperature at 1.5 m"
            },
            {
                "id": "ws9m",
                "type": "float",
                "units": "mps",
                "name": "wind speed at 9 m",
                "short_name": "wind speed at 9 m"
            },
            {
                "id": "wmx2",
                "type": "float",
                "units": "mps",
                "name": "maximum wind speed at 2 m",
                "short_name": "maximum wind speed at 2 m"
            },
            {
                "id": "rnet",
                "type": "float",
                "units": "wpsm",
                "name": "net radiation",
                "short_name": "net radiation"
            },
            {
                "id": "prta",
                "type": "float",
                "units": "nada",
                "name": "integrated temperature plate a",
                "short_name": "integrated temperature plate a"
            },
            {
                "id": "prtb",
                "type": "float",
                "units": "nada",
                "name": "integrated temperature plate b",
                "short_name": "integrated temperature plate b"
            },
            {
                "id": "hf5a",
                "type": "float",
                "units": "nada",
                "name": "heat flux plate a",
                "short_name": "heat flux plate a"
            },
            {
                "id": "hf5b",
                "type": "float",
                "units": "nada",
                "name": "heat flux plate b",
                "short_name": "heat flux plate b"
            },
            {
                "id": "irtt",
                "type": "float",
                "units": "cels",
                "name": "infrared target temperature",
                "short_name": "infrared target temperature"
            },
            {
                "id": "irth",
                "type": "float",
                "units": "cels",
                "name": "infrared housing temperature",
                "short_name": "infrared housing temperature"
            },
            {
                "id": "irtr",
                "type": "float",
                "units": "cels",
                "name": "infrared reference temperature",
                "short_name": "infrared reference temperature"
            },
            {
                "id": "skin",
                "type": "float",
                "units": "cels",
                "name": "skin temperature",
                "short_name": "skin temperature"
            }
        ],
        "derivation": [
            {
                "id": "skin",
                "func": "skin",
                "args": "irtt irth"
            },
            {
                "id": "tapp",
                "func": "tapp",
                "args": "tair relh wspd"
            },
            {
                "id": "chil",
                "func": "chil",
                "args": "tair wspd"
            },
            {
                "id": "chil2",
                "func": "chil2",
                "args": "tair wspd"
            },
            {
                "id": "palt",
                "func": "palt",
                "args": "pres elev"
            },
            {
                "id": "tdew",
                "func": "tdew",
                "args": "tair relh"
            },
            {
                "id": "dewd",
                "func": "diff",
                "args": "tair tdew"
            },
            {
                "id": "vdef",
                "func": "vdef",
                "args": "tair relh"
            },
            {
                "id": "vapr",
                "func": "vapr",
                "args": "tdew"
            },
            {
                "id": "vaps",
                "func": "vapr",
                "args": "tair"
            },
            {
                "id": "relh",
                "func": "relh",
                "args": "tair tdew"
            },
            {
                "id": "uwnd",
                "func": "uwnd",
                "args": "wspd wdir"
            },
            {
                "id": "vwnd",
                "func": "vwnd",
                "args": "wspd wdir"
            },
            {
                "id": "uwnd2",
                "func": "uwnd",
                "args": "ws2m wdir"
            },
            {
                "id": "vwnd2",
                "func": "vwnd",
                "args": "ws2m wdir"
            },
            {
                "id": "heat",
                "func": "heat",
                "args": "tair relh"
            },
            {
                "id": "thta",
                "func": "thta",
                "args": "tair pres"
            },
            {
                "id": "thte",
                "func": "thte",
                "args": "tair tdew pres"
            },
            {
                "id": "tvir",
                "func": "tvir",
                "args": "tair tdew pres"
            },
            {
                "id": "tlcl",
                "func": "tlcl",
                "args": "tair tdew"
            },
            {
                "id": "speh",
                "func": "speh",
                "args": "tdew pres"
            },
            {
                "id": "twet",
                "func": "wetb",
                "args": "tair tdew pres"
            },
            {
                "id": "mixr",
                "func": "mixr",
                "args": "pres tdew"
            },
            {
                "id": "mixs",
                "func": "mixr",
                "args": "pres tair"
            },
            {
                "id": "mp05",
                "func": "mp",
                "args": "tr05"
            },
            {
                "id": "mp25",
                "func": "mp",
                "args": "tr25"
            },
            {
                "id": "mp60",
                "func": "mp",
                "args": "tr60"
            },
            {
                "id": "mp75",
                "func": "mp",
                "args": "tr75"
            },
            {
                "id": "wc05",
                "func": "vwc",
                "args": "mp05 wcr05 wcs05 a05 n05"
            },
            {
                "id": "wc25",
                "func": "vwc",
                "args": "mp25 wcr25 wcs25 a25 n25"
            },
            {
                "id": "wc60",
                "func": "vwc",
                "args": "mp60 wcr60 wcs60 a60 n60"
            },
            {
                "id": "wc75",
                "func": "vwc",
                "args": "mp75 wcr75 wcs75 a75 n75"
            },
            {
                "id": "wcwp05",
                "func": "wcwp",
                "args": "wcr05 wcs05 a05 n05"
            },
            {
                "id": "wcwp25",
                "func": "wcwp",
                "args": "wcr25 wcs25 a25 n25"
            },
            {
                "id": "wcwp60",
                "func": "wcwp",
                "args": "wcr60 wcs60 a60 n60"
            },
            {
                "id": "fw05",
                "func": "fwi",
                "args": "tr05"
            },
            {
                "id": "fw25",
                "func": "fwi",
                "args": "tr25"
            },
            {
                "id": "fw60",
                "func": "fwi",
                "args": "tr60"
            },
            {
                "id": "fw75",
                "func": "fwi",
                "args": "tr75"
            },
            {
                "id": "cm05",
                "func": "cmp",
                "args": "mp05"
            },
            {
                "id": "cm25",
                "func": "cmp",
                "args": "mp25"
            },
            {
                "id": "cm60",
                "func": "cmp",
                "args": "mp60"
            },
            {
                "id": "cm75",
                "func": "cmp",
                "args": "mp75"
            },
            {
                "id": "dt05",
                "func": "diff",
                "args": "ft05 st05"
            },
            {
                "id": "dt25",
                "func": "diff",
                "args": "ft25 st25"
            },
            {
                "id": "dt60",
                "func": "diff",
                "args": "ft60 st60"
            },
            {
                "id": "dt75",
                "func": "diff",
                "args": "ft75 st75"
            },
            {
                "id": "rain",
                "func": "rain",
                "args": "rtip"
            },
            {
                "id": "rose",
                "func": "rose",
                "args": "wdir wspd"
            },
            {
                "id": "exsr",
                "func": "exsr",
                "args": "seconds lat lon"
            },
            {
                "id": "paw10",
                "func": "paw10",
                "args": "wcwp05 wc05"
            },
            {
                "id": "paw40",
                "func": "paw40",
                "args": "wcwp05 wcwp25 wc05 wc25"
            },
            {
                "id": "paw80",
                "func": "paw80",
                "args": "wcwp05 wcwp25 wcwp60 wc05 wc25 wc60"
            },
            {
                "id": "seconds",
                "func": "seconds"
            }
        ],
        "calibration": [
            {
                "id": "tr05",
                "func": "tref",
                "args": "dt05",
                "coeffs": "tr05c1 tr05c2"
            },
            {
                "id": "tr25",
                "func": "tref",
                "args": "dt25",
                "coeffs": "tr25c1 tr25c2"
            },
            {
                "id": "tr60",
                "func": "tref",
                "args": "dt60",
                "coeffs": "tr60c1 tr60c2"
            },
            {
                "id": "tr75",
                "func": "tref",
                "args": "dt75",
                "coeffs": "tr75c1 tr75c2"
            },
            {
                "id": "srad",
                "func": "srad",
                "args": "srad",
                "coeffs": "pyc1"
            },
            {
                "id": "pres",
                "func": "pres",
                "args": "pres"
            },
            {
                "id": "rnet",
                "func": "rnet",
                "args": "rnet ws2m exsr",
                "coeffs": "nrfc_day nrfc_night"
            },
            {
                "id": "fans",
                "func": "fans",
                "args": "fans",
                "coeffs": "fsc1"
            }
        ],
        "vector": [
            {
                "id": "wind10m",
                "name": "winds at 10 meters",
                "samag": "wspd",
                "vamag": "wvec",
                "dir": "wdir",
                "ucomp": "uwnd",
                "vcomp": "vwnd",
                "gust": "wmax"
            },
            {
                "id": "wind2m",
                "name": "winds at 2 meters",
                "samag": "ws2m",
                "vamag": "wvec",
                "dir": "wdir",
                "ucomp": "uwnd2",
                "vcomp": "vwnd2",
                "gust": "wmax"
            }
        ]
    },
    /**
     *	Color Indexes Swody Data.
     *
     * @type {Array}
     **/
    swody_color_index: {
        "categorical": {
            "TSTM": "#3b783c",
            "SLGT": "#fca522",
            "MDT": "#fb0216",
            "HIGH": "#fb1ffd"
        },
        "tornado": {
            "0.02": "#188b11",
            "0.05": "#8b4725",
            "0.10": "#fdc827",
            "0.15": "#fb0216",
            "0.30": "#fb1ffd",
            "0.45": "#912cee",
            "0.60": "#104e8a",
            "SIGN": "#000000"
        },
        "hail": {
            "0.05": "#8b4725",
            "0.15": "#fdc827",
            "0.30": "#fb0216",
            "0.45": "#fb1ffd",
            "0.60": "#912cee",
            "SIGN": "#000000"
        },
        "wind": {
            "0.05": "#8b4725",
            "0.15": "#fdc827",
            "0.30": "#fb0216",
            "0.45": "#fb1ffd",
            "0.60": "#912cee",
            "SIGN": "#000000"
        }
    },

    /**
     *	Gradient Color Indexes for all datatypes.
     *
     * @type {Array}
     **/
    gradient_color_index: {
        "tair": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "tair:fahr",
            "auto": "false",
            "max": "120",
            "min": "-20",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#AAAADDFF"
                },
                {
                    "index": "90",
                    "color": "#DDDDDDFF"
                },
                {
                    "index": "185",
                    "color": "#880088FF"
                },
                {
                    "index": "275",
                    "color": "#FF99FFFF"
                },
                {
                    "index": "365",
                    "color": "#00FFFFFF"
                },
                {
                    "index": "455",
                    "color": "#007FFFFF"
                },
                {
                    "index": "550",
                    "color": "#0000FFFF"
                },
                {
                    "index": "640",
                    "color": "#888888FF"
                },
                {
                    "index": "730",
                    "color": "#00FF00FF"
                },
                {
                    "index": "820",
                    "color": "#FFFF00FF"
                },
                {
                    "index": "915",
                    "color": "#FF8800FF"
                },
                {
                    "index": "1005",
                    "color": "#FF0000FF"
                },
                {
                    "index": "1095",
                    "color": "#880000FF"
                },
                {
                    "index": "1185",
                    "color": "#AA4488FF"
                },
                {
                    "index": "1275",
                    "color": "#FF88FFFF"
                }
            ]
        },
        "tdew": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "tdew:fahr",
            "auto": "false",
            "max": "80",
            "min": "0",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#440000FF"
                },
                {
                    "index": "125",
                    "color": "#660000FF"
                },
                {
                    "index": "430",
                    "color": "#FF9933FF"
                },
                {
                    "index": "640",
                    "color": "#FFFF00FF"
                },
                {
                    "index": "955",
                    "color": "#FFFF00FF"
                },
                {
                    "index": "1130",
                    "color": "#008800FF"
                },
                {
                    "index": "1275",
                    "color": "#002200FF"
                }
            ]
        },
        "chil": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "chil:fahr",
            "auto": "false",
            "max": "50",
            "min": "-60",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#330066FF"
                },
                {
                    "index": "330",
                    "color": "#FF99FFFF"
                },
                {
                    "index": "660",
                    "color": "#33CCFFFF"
                },
                {
                    "index": "975",
                    "color": "#0033CCFF"
                },
                {
                    "index": "1275",
                    "color": "#009999FF"
                }
            ]
        },
        "relh": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "relh:prct",
            "auto": "false",
            "max": "90",
            "min": "10",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#430700FF"
                },
                {
                    "index": "340",
                    "color": "#C96608FF"
                },
                {
                    "index": "685",
                    "color": "#FFFF00FF"
                },
                {
                    "index": "1020",
                    "color": "#3D9322FF"
                },
                {
                    "index": "1275",
                    "color": "#0E2907FF"
                }
            ]
        },
        "wspd": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "wspd:mph",
            "auto": "false",
            "max": "45",
            "min": "0",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#8DE5F2FF"
                },
                {
                    "index": "15",
                    "color": "#8DE5F2FF"
                },
                {
                    "index": "43",
                    "color": "#8BE790FF"
                },
                {
                    "index": "71",
                    "color": "#B0FA8CFF"
                },
                {
                    "index": "99",
                    "color": "#FFFF8CFF"
                },
                {
                    "index": "127",
                    "color": "#FFCC65FF"
                },
                {
                    "index": "156",
                    "color": "#FF9B00FF"
                },
                {
                    "index": "184",
                    "color": "#FF4B24FF"
                },
                {
                    "index": "212",
                    "color": "#E10724FF"
                },
                {
                    "index": "240",
                    "color": "#FF96FBFF"
                },
                {
                    "index": "1275",
                    "color": "#FF96FBFF"
                }
            ]
        },
        "wdir": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "wspd:mph",
            "auto": "false",
            "max": "360",
            "min": "0",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#0d82dfFF"
                },
                {
                    "index": "90",
                    "color": "#48a627FF"
                },
                {
                    "index": "180",
                    "color": "#d41243FF"
                },
                {
                    "index": "270",
                    "color": "#ffc726FF"
                },
                {
                    "index": "360",
                    "color": "#0d82dfFF"
                }
            ]
        },
        "rain": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "rain:inch",
            "auto": "false",
            "max": "5",
            "min": "0",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#0000FF00"
                },
                {
                    "index": "66",
                    "color": "#00F1F8FF"
                },
                {
                    "index": "126",
                    "color": "#1BEF00FF"
                },
                {
                    "index": "173",
                    "color": "#FFFF00FF"
                },
                {
                    "index": "1275",
                    "color": "#FF0C00FF"
                }
            ]
        },
        "srad": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "srad:wpsm",
            "auto": "false",
            "max": "1000",
            "min": "0",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#0000FFFF"
                },
                {
                    "index": "66",
                    "color": "#00F1F8FF"
                },
                {
                    "index": "126",
                    "color": "#1BEF00FF"
                },
                {
                    "index": "173",
                    "color": "#FFFF00FF"
                },
                {
                    "index": "1275",
                    "color": "#FF0C00FF"
                }
            ]
        },
        "vw05": {
            "src": "archivegrid",
            "name": "gradient",
            "alpha": "1.0",
            "parm": "vw05:nada",
            "auto": "false",
            "max": "1",
            "min": "0",
            "colorKey": [
                {
                    "index": "0",
                    "color": "#430700FF"
                },
                {
                    "index": "340",
                    "color": "#C96608FF"
                },
                {
                    "index": "685",
                    "color": "#FFFF00FF"
                },
                {
                    "index": "1020",
                    "color": "#3D9322FF"
                },
                {
                    "index": "1275",
                    "color": "#0E2907FF"
                }
            ]
        }


    },
    unit_displayunits: {
        'prct': '%',
        'nada': '',
        'kelv': ' K',
        'fahr': '&deg; F',
        'cels': '&deg; C',
        'kelvd': ' K',
        'fahrd': ' F&deg;',
        'celsd': ' C&deg;',
        'mbar': ' mb',
        'bar': ' bar',
        'inhg': ' in Hg',
        'psi': ' psi',
        'hpas': ' hPa',
        'kpas': ' kPa',
        'dcml': '',
        'mps': ' m/s',
        'kmph': ' km/h',
        'mph': ' mph',
        'knot': ' kt',
        'ftpm': 'ft/min',
        'tip': ' tips',
        'mm': ' mm',
        'cm': ' cm',
        'inch': ' in',
        'degr': ' &deg;',
        'rad': ' rad',
        'foot': ' ft',
        'yard': ' yd',
        'm': ' m',
        'dam': ' dam',
        'fath': ' fth',
        'fur': ' fur',
        'km': ' km',
        'kft': ' kft',
        'mile': ' mi',
        'nmi': ' nmi',
        'leag': ' lg',
        'secs': ' s',
        'min': ' min',
        'hour': ' hr',
        'day': ' days',
        'fort': ' ftnts',
        'volt': ' V',
        'mV': ' mV',
        'cV': ' cV',
        'Jpkg': ' J/kg',
        'kJpkg': ' kJ/kg',
        'MJpkg': ' MJ/kg',
        'mjsm': ' MJ/m^2',
        'jsm': 'J/m^2',
        'lgly': 'Ly',
        'g': ' g',
        'kg': ' kg',
        'gpkg': ' g/kg',
        'kgpkg': ' kg/kg',
        'dBZ': ' dBZ',
        'wpsm': ' W/m^2',
        'kgm2': ' kg/m^2',
        'm3m3': ' m^3/m^3',
        'deg2': ' deg^2',
        'm2s2': ' m^2/s^2',
        'btuft2': 'BTU/ft^2',
        'cmps': '&deg;C*m/s',
        'ft10': '10*ft'


    },
    watched_county_objs: {
        "ARC007": {
            "ID": "ARZ001",
            "CID": "ARC007",
            "NAME": "Benton"
        },
        "ARC015": {
            "ID": "ARZ002",
            "CID": "ARC015",
            "NAME": "Carroll"
        },
        "ARC033": {
            "ID": "ARZ019",
            "CID": "ARC033",
            "NAME": "Crawford"
        },
        "ARC047": {
            "ID": "ARZ020",
            "CID": "ARC047",
            "NAME": "Franklin"
        },
        "ARC057": {
            "ID": "ARZ060",
            "CID": "ARC057",
            "NAME": "Hempstead"
        },
        "ARC061": {
            "ID": "ARZ051",
            "CID": "ARC061",
            "NAME": "Howard"
        },
        "ARC071": {
            "ID": "ARZ021",
            "CID": "ARC071",
            "NAME": "Johnson"
        },
        "ARC073": {
            "ID": "ARZ071",
            "CID": "ARC073",
            "NAME": "Lafayette"
        },
        "ARC081": {
            "ID": "ARZ059",
            "CID": "ARC081",
            "NAME": "Little River"
        },
        "ARC083": {
            "ID": "ARZ030",
            "CID": "ARC083",
            "NAME": "Logan"
        },
        "ARC091": {
            "ID": "ARZ070",
            "CID": "ARC091",
            "NAME": "Miller"
        },
        "ARC097": {
            "ID": "ARZ041",
            "CID": "ARC097",
            "NAME": "Montgomery"
        },
        "ARC087": {
            "ID": "ARZ011",
            "CID": "ARC087",
            "NAME": "Madison"
        },
        "ARC109": {
            "ID": "ARZ052",
            "CID": "ARC109",
            "NAME": "Pike"
        },
        "ARC113": {
            "ID": "ARZ040",
            "CID": "ARC113",
            "NAME": "Polk"
        },
        "ARC127": {
            "ID": "ARZ037",
            "CID": "ARC127",
            "NAME": "Scott"
        },
        "ARC131": {
            "ID": "ARZ029",
            "CID": "ARC131",
            "NAME": "Sebastian"
        },
        "ARC133": {
            "ID": "ARZ050",
            "CID": "ARC133",
            "NAME": "Sevier"
        },
        "ARC143": {
            "ID": "ARZ010",
            "CID": "ARC143",
            "NAME": "Washington"
        },
        "ARC149": {
            "ID": "ARZ038",
            "CID": "ARC149",
            "NAME": "Yell"
        },
        "COC009": {
            "ID": "COZ099",
            "CID": "COC009",
            "NAME": "Baca"
        },
        "COC071": {
            "ID": "COZ094",
            "CID": "COC071",
            "NAME": "Las Animas"
        },
        "KSC191": {
            "ID": "KSZ092",
            "CID": "KSC191",
            "NAME": "Sumner"
        },
        "KSC189": {
            "ID": "KSZ085",
            "CID": "KSC189",
            "NAME": "Stevens"
        },
        "KSC187": {
            "ID": "KSZ074",
            "CID": "KSC187",
            "NAME": "Stanton"
        },
        "KSC175": {
            "ID": "KSZ086",
            "CID": "KSC175",
            "NAME": "Seward"
        },
        "KSC173": {
            "ID": "KSZ083",
            "CID": "KSC173",
            "NAME": "Sedgwick"
        },
        "KSC151": {
            "ID": "KSZ081",
            "CID": "KSC151",
            "NAME": "Pratt"
        },
        "KSC133": {
            "ID": "KSZ096",
            "CID": "KSC133",
            "NAME": "Neosho"
        },
        "KSC129": {
            "ID": "KSZ084",
            "CID": "KSC129",
            "NAME": "Morton"
        },
        "KSC125": {
            "ID": "KSZ099",
            "CID": "KSC125",
            "NAME": "Montgomery"
        },
        "KSC119": {
            "ID": "KSZ087",
            "CID": "KSC119",
            "NAME": "Meade"
        },
        "KSC099": {
            "ID": "KSZ100",
            "CID": "KSC099",
            "NAME": "Labette"
        },
        "KSC097": {
            "ID": "KSZ080",
            "CID": "KSC097",
            "NAME": "Kiowa"
        },
        "KSC095": {
            "ID": "KSZ082",
            "CID": "KSC095",
            "NAME": "Kingman"
        },
        "KSC081": {
            "ID": "KSZ076",
            "CID": "KSC081",
            "NAME": "Haskell"
        },
        "KSC077": {
            "ID": "KSZ091",
            "CID": "KSC077",
            "NAME": "Harper"
        },
        "KSC069": {
            "ID": "KSZ077",
            "CID": "KSC069",
            "NAME": "Gray"
        },
        "KSC007": {
            "ID": "KSZ090",
            "CID": "KSC007",
            "NAME": "Barber"
        },
        "KSC015": {
            "ID": "KSZ069",
            "CID": "KSC015",
            "NAME": "Butler"
        },
        "KSC019": {
            "ID": "KSZ098",
            "CID": "KSC019",
            "NAME": "Chautauqua"
        },
        "KSC021": {
            "ID": "KSZ101",
            "CID": "KSC021",
            "NAME": "Cherokee"
        },
        "KSC025": {
            "ID": "KSZ088",
            "CID": "KSC025",
            "NAME": "Clark"
        },
        "KSC033": {
            "ID": "KSZ089",
            "CID": "KSC033",
            "NAME": "Comanche"
        },
        "KSC035": {
            "ID": "KSZ093",
            "CID": "KSC035",
            "NAME": "Cowley"
        },
        "KSC037": {
            "ID": "KSZ097",
            "CID": "KSC037",
            "NAME": "Crawford"
        },
        "KSC049": {
            "ID": "KSZ094",
            "CID": "KSC049",
            "NAME": "Elk"
        },
        "KSC057": {
            "ID": "KSZ078",
            "CID": "KSC057",
            "NAME": "Ford"
        },
        "KSC067": {
            "ID": "KSZ075",
            "CID": "KSC067",
            "NAME": "Grant"
        },
        "KSC205": {
            "ID": "KSZ095",
            "CID": "KSC205",
            "NAME": "Wilson"
        },
        "MOC009": {
            "ID": "MOZ102",
            "CID": "MOC009",
            "NAME": "Barry"
        },
        "MOC011": {
            "ID": "MOZ077",
            "CID": "MOC011",
            "NAME": "Barton"
        },
        "MOC097": {
            "ID": "MOZ088",
            "CID": "MOC097",
            "NAME": "Jasper"
        },
        "MOC109": {
            "ID": "MOZ094",
            "CID": "MOC109",
            "NAME": "Lawrence"
        },
        "MOC119": {
            "ID": "MOZ101",
            "CID": "MOC119",
            "NAME": "McDonald"
        },
        "MOC145": {
            "ID": "MOZ093",
            "CID": "MOC145",
            "NAME": "Newton"
        },
        "NMC059": {
            "ID": "NMZ530",
            "CID": "NMC059",
            "NAME": "Union"
        },
        "OKC011": {
            "ID": "OKZ017",
            "CID": "OKC011",
            "NAME": "Blaine"
        },
        "OKC013": {
            "ID": "OKZ052",
            "CID": "OKC013",
            "NAME": "Bryan"
        },
        "OKC015": {
            "ID": "OKZ023",
            "CID": "OKC015",
            "NAME": "Caddo"
        },
        "OKC017": {
            "ID": "OKZ024",
            "CID": "OKC017",
            "NAME": "Canadian"
        },
        "OKC019": {
            "ID": "OKZ046",
            "CID": "OKC019",
            "NAME": "Carter"
        },
        "OKC021": {
            "ID": "OKZ068",
            "CID": "OKC021",
            "NAME": "Cherokee"
        },
        "OKC023": {
            "ID": "OKZ053",
            "CID": "OKC023",
            "NAME": "Choctaw"
        },
        "OKC025": {
            "ID": "OKZ001",
            "CID": "OKC025",
            "NAME": "Cimarron"
        },
        "OKC027": {
            "ID": "OKZ029",
            "CID": "OKC027",
            "NAME": "Cleveland"
        },
        "OKC029": {
            "ID": "OKZ043",
            "CID": "OKC029",
            "NAME": "Coal"
        },
        "OKC031": {
            "ID": "OKZ038",
            "CID": "OKC031",
            "NAME": "Comanche"
        },
        "OKC033": {
            "ID": "OKZ044",
            "CID": "OKC033",
            "NAME": "Cotton"
        },
        "OKC035": {
            "ID": "OKZ057",
            "CID": "OKC035",
            "NAME": "Craig"
        },
        "OKC037": {
            "ID": "OKZ064",
            "CID": "OKC037",
            "NAME": "Creek"
        },
        "OKC039": {
            "ID": "OKZ016",
            "CID": "OKC039",
            "NAME": "Custer"
        },
        "OKC041": {
            "ID": "OKZ063",
            "CID": "OKC041",
            "NAME": "Delaware"
        },
        "OKC043": {
            "ID": "OKZ015",
            "CID": "OKC043",
            "NAME": "Dewey"
        },
        "OKC045": {
            "ID": "OKZ009",
            "CID": "OKC045",
            "NAME": "Ellis"
        },
        "OKC047": {
            "ID": "OKZ012",
            "CID": "OKC047",
            "NAME": "Garfield"
        },
        "OKC049": {
            "ID": "OKZ040",
            "CID": "OKC049",
            "NAME": "Garvin"
        },
        "OKC051": {
            "ID": "OKZ027",
            "CID": "OKC051",
            "NAME": "Grady"
        },
        "OKC053": {
            "ID": "OKZ007",
            "CID": "OKC053",
            "NAME": "Grant"
        },
        "OKC055": {
            "ID": "OKZ034",
            "CID": "OKC055",
            "NAME": "Greer"
        },
        "OKC057": {
            "ID": "OKZ033",
            "CID": "OKC057",
            "NAME": "Harmon"
        },
        "OKC059": {
            "ID": "OKZ004",
            "CID": "OKC059",
            "NAME": "Harper"
        },
        "OKC061": {
            "ID": "OKZ074",
            "CID": "OKC061",
            "NAME": "Haskell"
        },
        "OKC063": {
            "ID": "OKZ032",
            "CID": "OKC063",
            "NAME": "Hughes"
        },
        "OKC065": {
            "ID": "OKZ036",
            "CID": "OKC065",
            "NAME": "Jackson"
        },
        "OKC067": {
            "ID": "OKZ045",
            "CID": "OKC067",
            "NAME": "Jefferson"
        },
        "OKC069": {
            "ID": "OKZ047",
            "CID": "OKC069",
            "NAME": "Johnston"
        },
        "OKC071": {
            "ID": "OKZ008",
            "CID": "OKC071",
            "NAME": "Kay"
        },
        "OKC073": {
            "ID": "OKZ018",
            "CID": "OKC073",
            "NAME": "Kingfisher"
        },
        "OKC075": {
            "ID": "OKZ035",
            "CID": "OKC075",
            "NAME": "Kiowa"
        },
        "OKC153": {
            "ID": "OKZ010",
            "CID": "OKC153",
            "NAME": "Woodward"
        },
        "OKC079": {
            "ID": "OKZ076",
            "CID": "OKC079",
            "NAME": "Le Flore"
        },
        "OKC081": {
            "ID": "OKZ026",
            "CID": "OKC081",
            "NAME": "Lincoln"
        },
        "OKC083": {
            "ID": "OKZ019",
            "CID": "OKC083",
            "NAME": "Logan"
        },
        "OKC085": {
            "ID": "OKZ050",
            "CID": "OKC085",
            "NAME": "Love"
        },
        "OKC087": {
            "ID": "OKZ028",
            "CID": "OKC087",
            "NAME": "McClain"
        },
        "OKC089": {
            "ID": "OKZ077",
            "CID": "OKC089",
            "NAME": "McCurtain"
        },
        "OKC091": {
            "ID": "OKZ071",
            "CID": "OKC091",
            "NAME": "McIntosh"
        },
        "OKC093": {
            "ID": "OKZ011",
            "CID": "OKC093",
            "NAME": "Major"
        },
        "OKC095": {
            "ID": "OKZ051",
            "CID": "OKC095",
            "NAME": "Marshall"
        },
        "OKC097": {
            "ID": "OKZ062",
            "CID": "OKC097",
            "NAME": "Mayes"
        },
        "OKC099": {
            "ID": "OKZ041",
            "CID": "OKC099",
            "NAME": "Murray"
        },
        "OKC101": {
            "ID": "OKZ070",
            "CID": "OKC101",
            "NAME": "Muskogee"
        },
        "OKC103": {
            "ID": "OKZ013",
            "CID": "OKC103",
            "NAME": "Noble"
        },
        "OKC105": {
            "ID": "OKZ056",
            "CID": "OKC105",
            "NAME": "Nowata"
        },
        "OKC107": {
            "ID": "OKZ065",
            "CID": "OKC107",
            "NAME": "Okfuskee"
        },
        "OKC109": {
            "ID": "OKZ025",
            "CID": "OKC109",
            "NAME": "Oklahoma"
        },
        "OKC111": {
            "ID": "OKZ066",
            "CID": "OKC111",
            "NAME": "Okmulgee"
        },
        "OKC113": {
            "ID": "OKZ054",
            "CID": "OKC113",
            "NAME": "Osage"
        },
        "OKC115": {
            "ID": "OKZ058",
            "CID": "OKC115",
            "NAME": "Ottawa"
        },
        "OKC117": {
            "ID": "OKZ059",
            "CID": "OKC117",
            "NAME": "Pawnee"
        },
        "OKC119": {
            "ID": "OKZ020",
            "CID": "OKC119",
            "NAME": "Payne"
        },
        "OKC121": {
            "ID": "OKZ073",
            "CID": "OKC121",
            "NAME": "Pittsburg"
        },
        "OKC123": {
            "ID": "OKZ042",
            "CID": "OKC123",
            "NAME": "Pontotoc"
        },
        "OKC125": {
            "ID": "OKZ030",
            "CID": "OKC125",
            "NAME": "Pottawatomie"
        },
        "OKC127": {
            "ID": "OKZ049",
            "CID": "OKC127",
            "NAME": "Pushmataha"
        },
        "OKC129": {
            "ID": "OKZ014",
            "CID": "OKC129",
            "NAME": "Roger Mills"
        },
        "OKC131": {
            "ID": "OKZ061",
            "CID": "OKC131",
            "NAME": "Rogers"
        },
        "OKC133": {
            "ID": "OKZ031",
            "CID": "OKC133",
            "NAME": "Seminole"
        },
        "OKC135": {
            "ID": "OKZ072",
            "CID": "OKC135",
            "NAME": "Sequoyah"
        },
        "OKC137": {
            "ID": "OKZ039",
            "CID": "OKC137",
            "NAME": "Stephens"
        },
        "OKC139": {
            "ID": "OKZ002",
            "CID": "OKC139",
            "NAME": "Texas"
        },
        "OKC141": {
            "ID": "OKZ037",
            "CID": "OKC141",
            "NAME": "Tillman"
        },
        "OKC143": {
            "ID": "OKZ060",
            "CID": "OKC143",
            "NAME": "Tulsa"
        },
        "OKC145": {
            "ID": "OKZ067",
            "CID": "OKC145",
            "NAME": "Wagoner"
        },
        "OKC147": {
            "ID": "OKZ055",
            "CID": "OKC147",
            "NAME": "Washington"
        },
        "OKC149": {
            "ID": "OKZ022",
            "CID": "OKC149",
            "NAME": "Washita"
        },
        "OKC151": {
            "ID": "OKZ005",
            "CID": "OKC151",
            "NAME": "Woods"
        },
        "OKC077": {
            "ID": "OKZ075",
            "CID": "OKC077",
            "NAME": "Latimer"
        },
        "OKC001": {
            "ID": "OKZ069",
            "CID": "OKC001",
            "NAME": "Adair"
        },
        "OKC003": {
            "ID": "OKZ006",
            "CID": "OKC003",
            "NAME": "Alfalfa"
        },
        "OKC005": {
            "ID": "OKZ048",
            "CID": "OKC005",
            "NAME": "Atoka"
        },
        "OKC007": {
            "ID": "OKZ003",
            "CID": "OKC007",
            "NAME": "Beaver"
        },
        "OKC009": {
            "ID": "OKZ021",
            "CID": "OKC009",
            "NAME": "Beckham"
        },
        "TXC111": {
            "ID": "TXZ001",
            "CID": "TXC111",
            "NAME": "Dallam"
        },
        "TXC119": {
            "ID": "TXZ106",
            "CID": "TXC119",
            "NAME": "Delta"
        },
        "TXC121": {
            "ID": "TXZ103",
            "CID": "TXC121",
            "NAME": "Denton"
        },
        "TXC129": {
            "ID": "TXZ019",
            "CID": "TXC129",
            "NAME": "Donley"
        },
        "TXC147": {
            "ID": "TXZ094",
            "CID": "TXC147",
            "NAME": "Fannin"
        },
        "TXC155": {
            "ID": "TXZ084",
            "CID": "TXC155",
            "NAME": "Foard"
        },
        "TXC159": {
            "ID": "TXZ108",
            "CID": "TXC159",
            "NAME": "Franklin"
        },
        "TXC179": {
            "ID": "TXZ014",
            "CID": "TXC179",
            "NAME": "Gray"
        },
        "TXC181": {
            "ID": "TXZ093",
            "CID": "TXC181",
            "NAME": "Grayson"
        },
        "TXC191": {
            "ID": "TXZ025",
            "CID": "TXC191",
            "NAME": "Hall"
        },
        "TXC195": {
            "ID": "TXZ003",
            "CID": "TXC195",
            "NAME": "Hansford"
        },
        "TXC197": {
            "ID": "TXZ083",
            "CID": "TXC197",
            "NAME": "Hardeman"
        },
        "TXC205": {
            "ID": "TXZ006",
            "CID": "TXC205",
            "NAME": "Hartley"
        },
        "TXC211": {
            "ID": "TXZ010",
            "CID": "TXC211",
            "NAME": "Hemphill"
        },
        "TXC223": {
            "ID": "TXZ107",
            "CID": "TXC223",
            "NAME": "Hopkins"
        },
        "TXC231": {
            "ID": "TXZ105",
            "CID": "TXC231",
            "NAME": "Hunt"
        },
        "TXC233": {
            "ID": "TXZ008",
            "CID": "TXC233",
            "NAME": "Hutchinson"
        },
        "TXC237": {
            "ID": "TXZ101",
            "CID": "TXC237",
            "NAME": "Jack"
        },
        "TXC269": {
            "ID": "TXZ038",
            "CID": "TXC269",
            "NAME": "King"
        },
        "TXC275": {
            "ID": "TXZ087",
            "CID": "TXC275",
            "NAME": "Knox"
        },
        "TXC277": {
            "ID": "TXZ095",
            "CID": "TXC277",
            "NAME": "Lamar"
        },
        "TXC295": {
            "ID": "TXZ005",
            "CID": "TXC295",
            "NAME": "Lipscomb"
        },
        "TXC337": {
            "ID": "TXZ091",
            "CID": "TXC337",
            "NAME": "Montague"
        },
        "TXC341": {
            "ID": "TXZ007",
            "CID": "TXC341",
            "NAME": "Moore"
        },
        "TXC343": {
            "ID": "TXZ111",
            "CID": "TXC343",
            "NAME": "Morris"
        },
        "TXC345": {
            "ID": "TXZ031",
            "CID": "TXC345",
            "NAME": "Motley"
        },
        "TXC357": {
            "ID": "TXZ004",
            "CID": "TXC357",
            "NAME": "Ochiltree"
        },
        "TXC375": {
            "ID": "TXZ012",
            "CID": "TXC375",
            "NAME": "Potter"
        },
        "TXC381": {
            "ID": "TXZ017",
            "CID": "TXC381",
            "NAME": "Randall"
        },
        "TXC387": {
            "ID": "TXZ096",
            "CID": "TXC387",
            "NAME": "Red River"
        },
        "TXC393": {
            "ID": "TXZ009",
            "CID": "TXC393",
            "NAME": "Roberts"
        },
        "TXC421": {
            "ID": "TXZ002",
            "CID": "TXC421",
            "NAME": "Sherman"
        },
        "TXC447": {
            "ID": "TXZ099",
            "CID": "TXC447",
            "NAME": "Throckmorton"
        },
        "TXC449": {
            "ID": "TXZ109",
            "CID": "TXC449",
            "NAME": "Titus"
        },
        "TXC483": {
            "ID": "TXZ015",
            "CID": "TXC483",
            "NAME": "Wheeler"
        },
        "TXC485": {
            "ID": "TXZ086",
            "CID": "TXC485",
            "NAME": "Wichita"
        },
        "TXC487": {
            "ID": "TXZ085",
            "CID": "TXC487",
            "NAME": "Wilbarger"
        },
        "TXC497": {
            "ID": "TXZ102",
            "CID": "TXC497",
            "NAME": "Wise"
        },
        "TXC503": {
            "ID": "TXZ100",
            "CID": "TXC503",
            "NAME": "Young"
        },
        "TXC087": {
            "ID": "TXZ020",
            "CID": "TXC087",
            "NAME": "Collingsworth"
        },
        "TXC085": {
            "ID": "TXZ104",
            "CID": "TXC085",
            "NAME": "Collin"
        },
        "TXC077": {
            "ID": "TXZ090",
            "CID": "TXC077",
            "NAME": "Clay"
        },
        "TXC075": {
            "ID": "TXZ026",
            "CID": "TXC075",
            "NAME": "Childress"
        },
        "TXC065": {
            "ID": "TXZ013",
            "CID": "TXC065",
            "NAME": "Carson"
        },
        "TXC067": {
            "ID": "TXZ112",
            "CID": "TXC067",
            "NAME": "Cass"
        },
        "TXC063": {
            "ID": "TXZ110",
            "CID": "TXC063",
            "NAME": "Camp"
        },
        "TXC037": {
            "ID": "TXZ097",
            "CID": "TXC037",
            "NAME": "Bowie"
        },
        "TXC023": {
            "ID": "TXZ088",
            "CID": "TXC023",
            "NAME": "Baylor"
        },
        "TXC011": {
            "ID": "TXZ018",
            "CID": "TXC011",
            "NAME": "Armstrong"
        },
        "TXC009": {
            "ID": "TXZ089",
            "CID": "TXC009",
            "NAME": "Archer"
        },
        "TXC097": {
            "ID": "TXZ092",
            "CID": "TXC097",
            "NAME": "Cooke"
        },
        "TXC101": {
            "ID": "TXZ032",
            "CID": "TXC101",
            "NAME": "Cottle"
        }
    }
};
// Once the document is ready, load in the following settings
document.addEventListener("DOMContentLoaded", function (event) {
    OCS.Viewer.Config.dataworker.class_options.xmpp_login_device = OCS.Viewer.Functions.get_xmpp_device_name();
});
